export const CATEGORIES = ["Prayer", "Devotionals", "Chants", "Hymns/Songs", "Activities"];

export const CATEGORY_STYLES = {
  Prayer: { badge: "bg-amber-100 text-amber-900 border-amber-300 dark:bg-amber-950/60 dark:text-amber-300 dark:border-amber-800", header: "bg-amber-800 text-amber-50", border: "border-amber-800" },
  Devotionals: { badge: "bg-indigo-100 text-indigo-900 border-indigo-300 dark:bg-indigo-950/60 dark:text-indigo-300 dark:border-indigo-800", header: "bg-indigo-900 text-indigo-50", border: "border-indigo-900" },
  Chants: { badge: "bg-purple-100 text-purple-900 border-purple-300 dark:bg-purple-950/60 dark:text-purple-300 dark:border-purple-800", header: "bg-purple-900 text-purple-50", border: "border-purple-900" },
  "Hymns/Songs": { badge: "bg-emerald-100 text-emerald-900 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-800", header: "bg-emerald-900 text-emerald-50", border: "border-emerald-900" },
  Activities: { badge: "bg-stone-200 text-stone-900 border-stone-300 dark:bg-stone-800 dark:text-stone-200 dark:border-stone-700", header: "bg-stone-800 text-stone-100", border: "border-stone-800" },
};

export function computeTimeRanges(startTime, segments) {
  const [h, m] = (startTime || "09:00").split(":").map(Number);
  let cursor = new Date(2000, 0, 1, h || 9, m || 0);
  const ranges = [];
  for (const seg of segments) {
    const start = new Date(cursor);
    cursor = new Date(cursor.getTime() + (seg.duration_minutes || 5) * 60000);
    ranges.push({ start, end: new Date(cursor) });
  }
  return ranges;
}

export function formatTime(date) {
  return date.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
}

export function totalDuration(segments) {
  return segments.reduce((sum, s) => sum + (s.duration_minutes || 0), 0);
}
